import { render, staticRenderFns } from "./CardTic.vue?vue&type=template&id=4afcbd19&scoped=true&"
import script from "./CardTic.vue?vue&type=script&lang=ts&"
export * from "./CardTic.vue?vue&type=script&lang=ts&"
import style0 from "./CardTic.vue?vue&type=style&index=0&id=4afcbd19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afcbd19",
  null
  
)

export default component.exports